module.exports = __webpack_public_path__ + "media/images/bottom-background-dark-0f8a4278.svg";